import { MAX_COMMUNITY_NAME_LENGTH, useCommunitySwitcher } from 'hooks/useCommunitySwitcher';
import { useTranslation } from 'react-i18next';
import { truncateText } from 'utils/textHelpers';

import React, { useMemo } from 'react';

import { Button } from '@thinkific/chalk/Button';
import { Text } from '@thinkific/chalk/Text';
import { atomic } from '@thinkific/chalk/atomic';
import { CaretDown } from '@thinkific/chalk/react-icons';

import { useCommunityContext } from 'components/CommunityContext';
import CommunityHeader from 'components/CommunityHeader/CommunityHeader';
import HomeFeed from 'components/HomeFeed';
import { getLayout } from 'components/Layouts/MainLayout';
import Layout from 'components/new/layout';
import { CommunitySwitcherPopover } from 'components/new/layout/CommunitySwitcherPopover/CommunitySwitcherPopover';

interface IndexPageProps {
  postListState: {
    useCacheFirst: boolean;
  };
}

const CommunityTitleStyle = atomic({
  display: 'flex',
  alignItems: 'center',
  gap: 'space.100',
});

const IndexPage = ({ postListState }: IndexPageProps) => {
  const { t } = useTranslation();
  const { community, currentUser } = useCommunityContext();
  const { communities } = useCommunitySwitcher();

  const truncatedCommunityName = useMemo(
    () => truncateText(community.name, MAX_COMMUNITY_NAME_LENGTH),
    [community.name]
  );

  const { firstName } = currentUser;

  return (
    <>
      <CommunityHeader pageTitle={t('pages-home_title', 'Home')} />
      <Layout.ContextHeader
        pageTitle={
          communities.length > 1 ? (
            <div className={CommunityTitleStyle}>
              <Text as="h2" variant="display.md">
                {truncatedCommunityName}
              </Text>
              <CommunitySwitcherPopover>
                <Button emphasis="low" icon={CaretDown} size="xs" hiddenLabel>
                  {t('components-topBar_menu', 'Communities switcher menu')}
                </Button>
              </CommunitySwitcherPopover>
            </div>
          ) : (
            community.name
          )
        }
      />
      <Layout.PageContent>
        <HomeFeed community={community} firstName={firstName} postListState={postListState} />
      </Layout.PageContent>
    </>
  );
};

IndexPage.getLayout = getLayout;

export default IndexPage;
